import { defineComponent as _defineComponent } from 'vue'
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { IHeaderJson } from 'JS/types/Header';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderStores',
  props: {
    headerData: null
  },
  setup(__props: any) {

const props = __props as {
	headerData: IHeaderJson
}



const setStoreMenuOpen = ref(false);

return { __sfc: true,props, setStoreMenuOpen, ChangeStoreSideMenu, Icon, LinkButton }
}

})